import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-soft transition-all duration-300 hover:bg-primary-700 md:right-8 ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}